import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "s-modal--portal--container" }
const _hoisted_2 = { class: "s-mb-xl" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = {
  key: 0,
  class: "s-modal--pattern"
}


import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { REGION_ENVIRONMENT } from 'PortalDir/constants/app/common';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'PortalDialog' },
  __name: 'PortalDialog',
  props: {
    title: {},
    pattern: { type: Boolean, default: false },
    info: { type: Boolean, default: false },
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emits = __emit;
const { innerValue, emitValue } = useValue(props, emits);
const { t } = useI18n();


return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _unref(innerValue),
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
      _unref(emitValue)
    ]
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "s-modal s-modal--small s-modal--portal" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_q_card_section, { class: "text-center s-mb-md" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("a", {
                    href: _unref(t)('siteDepartment'),
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, [
                    _createElementVNode("img", {
                      src: `${_unref(REGION_ENVIRONMENT)}/images/logo.svg`
                    }, null, 8, _hoisted_4)
                  ], 8, _hoisted_3)
                ]),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.title), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "s-mb-xl" }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }),
            (_ctx.$slots.footer)
              ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "footer")
                  ]),
                  _: 3
                }))
              : _createCommentVNode("", true)
          ]),
          (_ctx.pattern)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["modelValue", "onUpdate:modelValue"]))
}
}

})